import React from "react";
import Header from "../../../layouts/AuthLayout/header/header";
import CustomerCartListSection from "./customer-cart-list-section";

export default function CustomerCartListPage() {
  return (
    <>
      <Header />
      <CustomerCartListSection />
    </>
  );
}
